import { isValidSiteLocale } from "@features/market/config/market-config";

export const getDetailsFromPathname = (
  pathname: string,
): { locale: string; slug: string[] | undefined } => {
  const slugs = pathname.split("/").filter(Boolean);
  const [locale, ...rest] = slugs;

  if (!locale) {
    return {
      locale: "",
      slug: [],
    };
  }

  if (!isValidSiteLocale(locale)) {
    return {
      locale: "",
      slug: [locale, ...rest],
    };
  }

  return {
    locale,
    slug: rest,
  };
};
